import { render, staticRenderFns } from "./audits.vue?vue&type=template&id=0af16cdc&scoped=true"
import script from "./audits.vue?vue&type=script&lang=ts"
export * from "./audits.vue?vue&type=script&lang=ts"
import style0 from "./audits.vue?vue&type=style&index=0&id=0af16cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af16cdc",
  null
  
)

export default component.exports